export default {
  SET_PLAYING_VIDEO: 'SET_PLAYING_VIDEO',
  SET_IS_PLAYING: 'SET_IS_PLAYING',
  SET_IS_BUFFERING: 'SET_IS_BUFFERING',
  SET_IS_LOADING: 'SET_IS_LOADING',
  SET_IS_ADVERTISEMENT: 'SET_IS_ADVERTISEMENT',
  SET_IS_MUTED: 'SET_IS_MUTED'
};
